import React from "react";
import "./TCIOnCloud.css";
import TCIOnCloudOverview from "./TCIOnCloudOverview";
import BannerImage from "../../../assets/other_image/cloud.jpg";
import Letsgetintouch from "../BusinessProcessAndChangeManagement/Letsgetintouch";
import { NavLink } from "react-router-dom";
import Banner from "../Banner/Banner";
import FloatingContactUs from "../../floting_contact/FloatingContactUs";
import { Helmet } from "react-helmet-async";


const TCIOnCloud = () => {
  return (
    <>
    <Helmet>
      <title>Teamcenter Cloud Implementation Services in Pune | NexTech PLM</title>
      <meta name="description" content="Move your Teamcenter to the cloud with professional implementation services in Pune, India. Nextech PLM provides secure and scalable solutions." />
      <meta name="keywords" content="Teamcenter cloud implementation, Teamcenter on AWS Azure, cloud PLM Pune, Teamcenter cloud deployment India, PLM cloud migration services" />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <link rel="canonical" href="https://nextechplm.com/teamcenter-cloud-implementation" />
      <meta property="og:site_name" content="NexTech PLM Solutions" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="Teamcenter Cloud Implementation Services in Pune | NexTech PLM" />
      <meta property="og:description" content="Move your Teamcenter to the cloud with professional implementation services in Pune, India. Nextech PLM provides secure and scalable solutions." />
      <meta property="og:url" content="https://nextechplm.com/teamcenter-cloud-implementation" />
      <meta property="og:image" content="https://nextechplm.com/logo192.png" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Teamcenter Cloud Implementation Services in Pune | NexTech PLM" />
      <meta name="twitter:description" content="Move your Teamcenter to the cloud with professional implementation services in Pune, India. Nextech PLM provides secure and scalable solutions." />
      <meta name="twitter:image" content="https://nextechplm.com/logo192.png" />
    </Helmet>

    <section className="TCIOnCloud-management">
     <Banner
        image={BannerImage} // Pass the image for this page
        heading="Teamcenter Implementation on Cloud" // Pass the heading text for this page
      />
      <div>
         <FloatingContactUs />
      </div>


      <TCIOnCloudOverview />
      <section style={{ background: "#f5f7fa" }}>
        <div className="benefits container">
          <h4 className="TCIOnCloud-page-heading">Unlock the Power :</h4>
          <h5 className="TCIOnCloud-subheading">
            Discover the Transformative Benefits of Teamcenter Implementation on Cloud with NexTech!
          </h5>
          <ul className="custom-bullets">
            <li>
              Faster Time to Value with quick deployment on the Cloud and
              shorter solution delivery time{" "}
            </li>
            <li>
              Lower total cost of ownership with the most optimized deployment
              on the Cloud{" "}
            </li>
            <li>
              Highly available, performant, and secured Teamcenter PLM system
              for your business{" "}
            </li>
          </ul>
        </div>
      </section>
      <section>
  <div className="solutions container">
    <div className="solutions-content">
      <div className="row">
        <div className="col-md-6 col-12">
          <h4 className="TCIOnCloud-page-heading">Teamcenter Solutions</h4>

          <ul className="custom-bullets">
          <li>Implement on AWS</li>
            <li>Implement on Azure</li>
            <li>Implement on Teamcenter</li>
            <li>Implement on Teamcenter X </li>
          </ul>
 
        </div>

        <div className="col-md-6 col-12">
          <div className="quick-links">
            <h4>Quick Links</h4>
            <ul>
            <li>
                      <NavLink to={"/teamcenter/implementation"}>
                        Teamcenter Implementation
                      </NavLink>
                    </li>

                    <li>
                      <NavLink to={"/teamcenter/cae-integration"}>
                        Teamcenter Integration for CAE
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to={"/teamcenter/cam-integration"}>
                        Teamcenter Integration for CAM
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to={"/teamcenter/performance-tuning-health-checkup"}
                      >
                        Teamcenter Performance Tuning & Health Check-up
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to={"/teamcenter/program-project-management"}>
                        Teamcenter Project Management
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to={"/teamcenter/rac-to-aw-client-transition"}>
                      Teamcenter RAC to Active Workspace Client Transition
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to={"/teamcenter/upgrade-migration"}>
                      Teamcenter Upgrade & Migration
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to={"/teamcenter/aw-client"}>
                      Implementation of Teamcenter AW Client
                      </NavLink>
                    </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
      <section style={{ background: "#f5f7fa" }}>
        <div className="why-nextech container">
          <h4 className="TCIOnCloud-page-heading">Why NexTech?</h4>
          <h5 className="TCIOnCloud-subheading">
            For Teamcenter Implementation on Cloud Solution{" "}
          </h5>
          <ul className="custom-bullets">
            <li>
              Rapid deployment on AWS or Azure, ensuring faster time to value
              and shorter solution delivery time, enabling businesses to quickly
              leverage the benefits of Teamcenter PLM.
            </li>
            <li>
              Optimized deployment on the Cloud leading to lower total cost of
              ownership, providing cost-effectiveness and efficient resource
              utilization.
            </li>
            <li>
              Ensuring a highly available, performant, and secured Teamcenter
              PLM system tailored to meet the specific needs of the business,
              enhancing global collaboration and productivity.
            </li>
            <li>
              Expertise in implementing both traditional Teamcenter PLM and the
              advanced Teamcenter X on various cloud platforms, offering
              flexibility and scalability to align with business requirements.
            </li>
            <li>
              Comprehensive offerings covering implementation on AWS, Azure,
              Teamcenter, and Teamcenter X, providing tailored solutions for
              diverse business needs and cloud preferences.
            </li>
          </ul>
        </div>
      </section>
      <Letsgetintouch />
    </section>
</>
  );
};

export default TCIOnCloud;
